/** GraphQL selection for customer dropdowns (the fields any signed-in user may read: names, no personal data). */
export const CUSTOMER_DROPDOWN_QUERY = `
  id
  entityId
  mainInfo { firstName lastName }
  enabled
`;
